export const buildClassInstanceFilterGroups = (statusOptions, templateOptions, venueOptions, instructorOptions) => [
  {
    id: "class",
    label: "Class",
    filters: [
      {
        id: "status",
        label: "Status",
        type: "checkbox",
        options: statusOptions || [],
      },
      {
        id: "template",
        label: "Template",
        type: "checkbox",
        options: templateOptions || [],
      },
      {
        id: "venue",
        label: "Venue",
        type: "checkbox",
        options: venueOptions || [],
      },
      {
        id: "instructor",
        label: "Instructor",
        type: "checkbox",
        options: instructorOptions || [],
      },
      {
        id: "waitlist",
        label: "Waitlist",
        type: "checkbox",
        options: [{ value: "has_waitlist", label: "Has waitlist" }],
      },
    ],
  },
  {
    id: "dates",
    label: "Dates",
    filters: [
      { id: "class_date", label: "Class Date", type: "date_range", options: [] },
      { id: "created_at", label: "Created Date", type: "date_range", options: [] },
    ],
  },
];
